//import React from 'react'
//import Nav from './navbar-hp';
//import { Outlet, Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react"
import "98.css";

import Notepad from './notepad.js';
import Photos from './photos.js';
import Gallery from './gallery.js';
import PhotoViewer from './photoViewer.js'
//import { render } from '@testing-library/react';
//import { data } from 'jquery';
//import { act } from 'react';
//import { setSelectionRange } from '@testing-library/user-event/dist/utils/index.js';

export default function Explorer({openSnake, openContactForm}) {

    useEffect(() => {
        clearActiveWindow();
        //document.querySelector('.window-container').append(document.querySelector('.window[data-name="Explorer"]'));
        
        return () => {
            //console.log('Component will unmount');
        };
    }, []);

    const [enable, setEnable] = useState(true);
    const [track, setTrack] = useState('none');
    const [renderGallery, setRenderGallery] = useState(false);

    const [activeNotepad, setActiveNotepad] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activePhotoViewer, setActivePhotoViewer] = useState(0);
    const [selectedPhoto, setselectedPhoto] = useState('none');
    
    const [imgIndex, setImgIndex] = useState(null);

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function showWindow(e) {
        var el = e.target;
        //console.log('showWindow ' + e.target)
        var dataName = el.getAttribute('data-name');
        if (document.querySelector('.window[data-name="' + dataName +'"]') && document.querySelector('.window[data-name="' + dataName +'"]').classList.contains('hidden')) {
            //document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            clearActiveWindow();
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
            var el = e.target;
            //console.log(el);
            checkTray(el);
            document.querySelector('.window[data-name="' + dataName +'"]').classList.remove('hidden');
        }
        var song = el.getAttribute('data-song');
        setTrack(song);
        //console.log('showWindow ' + dataName)
        if (dataName === 'Image') {
            if (!activeIndex) {
                clearActiveWindow();
                setActiveIndex(1);
            }
        }
        if (dataName === 'Notepad') {
            if (!activeNotepad) {
                clearActiveWindow();
                setActiveNotepad(1);
            }
        }
    }

    function showViewer(e) {
        clearActiveWindow();
        setActivePhotoViewer(1)
        var el = e.target;
        //console.log(el)
        //var dataName = el.getAttribute('data-name');
        var photo = el.getAttribute('data-photo');
        setselectedPhoto(photo)
        var index = Array.from(document.querySelectorAll('.window-body.photos .item')).indexOf(el.parentElement);
        setImgIndex(index);
    }

    function getNextImg() {
        var maxIndex = document.querySelectorAll('.window-body.photos .item').length - 1;
        var nextImgIndex = imgIndex + 1;
        if (nextImgIndex > maxIndex) {
            nextImgIndex = 0;
        }
        setImgIndex(nextImgIndex);
        var nextImg = document.querySelectorAll('.window-body.photos .item')[nextImgIndex].querySelector('[data-name="Photo Viewer"]').getAttribute('data-photo');
        document.querySelector('.window[data-name="Photo Viewer"] .title-bar-text').innerText = nextImg;
        nextImg = '/images/gallery2/' + nextImg;
        //console.log(nextImg);
        document.querySelector('.window[data-name="Photo Viewer"] .window-body img').src = nextImg;
    }

    function getPrevImg() {
        var maxIndex = document.querySelectorAll('.window-body.photos .item').length - 1;
        var prevImgIndex = imgIndex - 1;
        if (prevImgIndex < 0) {
            prevImgIndex = maxIndex;
        }
        setImgIndex(prevImgIndex);
        var nextImg = document.querySelectorAll('.window-body.photos .item')[prevImgIndex].querySelector('[data-name="Photo Viewer"]').getAttribute('data-photo');
        document.querySelector('.window[data-name="Photo Viewer"] .title-bar-text').innerText = nextImg;
        nextImg = '/images/gallery2/' + nextImg;
        //console.log(nextImg);
        document.querySelector('.window[data-name="Photo Viewer"] .window-body img').src = nextImg;
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    // function reOpen(selector) {
        
    //     document.querySelectorAll('.tray button').forEach(item => {
    //         item.removeAttribute('aria-selected');
    //     });

    //     var selector = selector.target;
    //     //console.log(selector);
    //     var dataName = selector.getAttribute('data-name');

    //     document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));

    //     if (document.querySelector('.window[data-name="' + dataName + '"]')) {
    //         selector.ariaSelected = 'true';
    //         document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
    //     }
    // }

    function reOpen(selector) {

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.getAttribute('data-name');
        // console.log(selector)
        // console.log(selector.nodeName)
        // console.log(dataName)

        if (!dataName) {
            dataName = selector.closest('.window').getAttribute('data-name');
            clearActiveWindow();
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName + '"]'));
            return;
        }

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;

        if (selector.nodeName !== 'BUTTON' && (dataName === 'Image' || dataName === 'Notepad' || dataName === 'Photo Viewer' || dataName === 'Contact Form')) {

            if (dataName === 'Notepad') {
                if (activeNotepad) {
                    //document.querySelector('.window-container').append(document.querySelector('.window[data-name="Notepad"]'));
                    clearActiveWindow();
                    document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
                    document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
                    document.querySelector('.window-container').append(document.querySelector('.window[data-name="Notepad"]'));
                }
            }
            if (dataName === 'Image') {
                if (activeIndex) {
                    //document.querySelector('.window-container').append(document.querySelector('.window[data-name="Image"]'));
                    clearActiveWindow();
                    document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
                    document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
                    document.querySelector('.window-container').append(document.querySelector('.window[data-name="Image"]'));
                }
            }
            if (dataName === 'Photo Viewer') {
                if (activePhotoViewer) {
                    clearActiveWindow();
                    document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
                    document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                    document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
                    document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName + '"]'));
                }
            }
            if (dataName === 'Contact Form') {
                clearActiveWindow();
                document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName + '"]'));
            }

        } else {
        
            //console.log('data-name = ' + dataName)
            //Toolbar tab buttons
            if (selector.nodeName === 'BUTTON' && selector.classList.contains('toolbar-tab')) {
                //console.log('tabs click');
                dataName = selector.getAttribute('data-name');
                if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                    selector.ariaSelected = 'true';
                    document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                    document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName + '"]'));
                }
            // } else if (dataName === 'Photo Viewer') {
            //     selector = document.querySelector('.window[data-name="Photo Viewer"]');
            //     dataName = selector.getAttribute('data-name');
            } else {
                selector = selector.closest('.window');
                //console.log('closest window')
                dataName = selector.getAttribute('data-name');

            }

            //console.log(dataName)
            clearActiveWindow();
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
            document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName + '"]'));

        }

        // clearActiveWindow();
        // document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');

        // document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';

        /*
        if (selector.nodeName === 'BUTTON') {
            if (selector.classList.contains('form-minimise') || selector.classList.contains('form-close')) return;

            console.log('btn = ' + selector);
            var dataName = selector.getAttribute('data-name');
        } else if (selector.closest('.window-body') && selector.closest('.window-body').classList.contains('photos')) {
            return;
        } else {
            selector = selector.closest('.window');
            var dataName = selector.getAttribute('data-name');
            console.log('dataName = ' + dataName)
        }

        //document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        clearActiveWindow();
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        if (document.querySelector('.window[data-name="' + dataName +'"]').classList.contains('hidden')) document.querySelector('.window[data-name="' + dataName +'"]').classList.remove('hidden')

        if (document.querySelector('.window[data-name="' + dataName + '"]')) {
            selector.ariaSelected = 'true';
            document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
        }

        document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        */
    }
    
    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function hideExplorer(e) {
        var el = e.target;
        //console.log(el);
        var dataName = el.getAttribute('data-name');
        checkTray(el, true);
        document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
        resetExplorer();
    }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.classList.add('toolbar-tab');
            if (dataName === 'Image') {
                el.innerText = selector.innerText;
            } else {
                el.innerText = dataName;
            }
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    function openFolder(e) {
        var name = e.target.getAttribute('data-folder');
        var previous = document.querySelector('.window[data-name="Explorer"] .window-body:not(.hidden)').getAttribute('data-folder')
        document.querySelector('.window[data-name="Explorer"] .window-body:not(.hidden)').classList.add('hidden');
        document.querySelector('.window[data-name="Explorer"] .window-body[data-folder="' + name + '"]').classList.remove('hidden');
        document.querySelector('.window[data-name="Explorer"] .toolbar-button.back-button').setAttribute('data-folder', previous);

        if (name === "Photos") {
            setRenderGallery(true);
        }

        if (name !== "Home") {
            document.querySelector('#address-bar .bar').insertAdjacentHTML('beforeend', '<div class="bar-item"><span>&#92;</span><span class="data-folder" data-folder="' + name + '">' + name + '</span></div>');
        }
        setEnable(false)
    }

    function resetExplorer() {
        document.querySelectorAll('.window[data-name="Explorer"] .window-body').forEach(window =>{
            window.classList.add('hidden');
        })
        document.querySelector('.window[data-name="Explorer"] .window-body[data-folder="Home"]').classList.remove('hidden');

        document.querySelectorAll('.window[data-name="Explorer"] .bar-item').forEach(item => {
            if (Array.from(document.querySelectorAll('.window[data-name="Explorer"] .bar-item')).indexOf(item) > 0) {
                item.remove();
            }
        })

        setEnable(true)
        //setTrack('none')
        setRenderGallery(false)
        //setActiveIndex(0)
        closeViewer()
        //closePhoto()
    }

    function previousFolder(e) {
        if (e.target.getAttribute('data-folder')) {
            var name = e.target.getAttribute('data-folder');
        } else if (e.target.parentElement.getAttribute('data-folder')) {
            var name = e.target.parentElement.getAttribute('data-folder');
        }
        document.querySelectorAll('.window[data-name="Explorer"] .window-body').forEach(window =>{
            window.classList.add('hidden');
        })

        if (document.querySelectorAll('#address-bar .bar .bar-item .data-folder').length > 2) {
            document.querySelectorAll('#address-bar .bar .bar-item .data-folder')[document.querySelectorAll('#address-bar .bar .bar-item .data-folder').length-1].parentElement.remove();

            var prevFolder = document.querySelectorAll('#address-bar .bar .bar-item .data-folder')[document.querySelectorAll('#address-bar .bar .bar-item .data-folder').length-2].getAttribute('data-folder');

            //console.log(prevFolder)
        
            document.querySelector('.window[data-name="Explorer"] .toolbar-button.back-button').setAttribute('data-folder', prevFolder);

            document.querySelector('.window[data-name="Explorer"] .window-body[data-folder="' + name + '"]').classList.remove('hidden');
            
            /*
            if (prevFolder === "Home") {
                document.querySelector('.window[data-name="Explorer"] .toolbar-button.back-button').removeAttribute('data-folder');
                setEnable(true)
            }
            */
        } else if (name === "Home") {
            document.querySelectorAll('#address-bar .bar .bar-item .data-folder')[document.querySelectorAll('#address-bar .bar .bar-item .data-folder').length-1].parentElement.remove();
            document.querySelector('.window[data-name="Explorer"] .window-body[data-folder="' + name + '"]').classList.remove('hidden');
            document.querySelector('.window[data-name="Explorer"] .toolbar-button.back-button').removeAttribute('data-folder');
            setEnable(true)
        }
    }

    function closePhoto() {
        setActiveIndex(0);
        var dataName = 'Image';
        var tray = document.querySelector('.tray');
        if (tray.querySelector('[data-name="' + dataName + '"]')) tray.querySelector('[data-name="' + dataName + '"]').remove();
    }

    function closeNotepad() {
        setActiveNotepad(0);
        var dataName = 'Notepad';
        var tray = document.querySelector('.tray');
        if (tray.querySelector('[data-name="' + dataName + '"]')) tray.querySelector('[data-name="' + dataName + '"]').remove();
    }

    function closeViewer() {
        setActivePhotoViewer(0);
        var dataName = 'Photo Viewer';
        var tray = document.querySelector('.tray');
        if (tray.querySelector('[data-name="' + dataName + '"]')) tray.querySelector('[data-name="' + dataName + '"]').remove();
    }
    
    let NotepadComponent;
    if (activeNotepad === 1) {
        NotepadComponent = <Notepad fileName={track.replace(/ /g,'')} songName={track} onClose={closeNotepad} />
        //<Photos type="artwork" fileName={track.replace(/ /g,'')} name={track} isActive={activeIndex} onClose={closePhoto} />
        
        var dataName = 'Notepad';
        var tray = document.querySelector('.tray');
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.classList.add('toolbar-tab');
            el.innerText = track.replace(/ /g,'') + '.txt';
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        } else if (tray.querySelector('[data-name="' + dataName + '"]')) {
            tray.querySelector('[data-name="' + dataName + '"]').innerText = track.replace(/ /g,'') + '.txt';
        }
    }

    let PhotoComponent;
    if (activeIndex === 1) {
        PhotoComponent = <Photos type="artwork" fileName={track.replace(/ /g,'')} name={track} isActive={activeIndex} onClose={closePhoto} />
        
        var dataName = 'Image';
        var tray = document.querySelector('.tray');
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.classList.add('toolbar-tab');
            el.innerText = track.replace(/ /g,'')  + '.jpg';
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        } else if (tray.querySelector('[data-name="' + dataName + '"]')) {
            tray.querySelector('[data-name="' + dataName + '"]').innerText = track.replace(/ /g,'') + '.jpg';
        }
    }

    let PhotoViewerWindow;
    if (activePhotoViewer === 1) {
        PhotoViewerWindow = <PhotoViewer name={selectedPhoto} onClose={closeViewer} onNextClick={getNextImg} onPrevClick={getPrevImg}/>
        
        var dataName = 'Photo Viewer';
        var tray = document.querySelector('.tray');
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.classList.add('toolbar-tab');
            el.innerText = 'Photo Viewer'
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        }
    }

    return (
        <>

        {PhotoComponent}
        {PhotoViewerWindow}
        {NotepadComponent}

        {/* <Notepad fileName={track.replace(/ /g,'')} songName={track} /> */}

        <div className="window hidden" data-name="Explorer" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">Explorer</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Explorer"></button>
                    <button className="form-close" aria-label="Close" onClick={hideExplorer} data-name="Explorer"></button>
                </div>
            </div>

            <div className="navigation">
                <div className="nav-button">File</div>
                <div className="nav-button">Edit</div>
                <div className="nav-button">View</div>
                <div className="nav-button">Go</div>
                <div className="nav-button">Tools</div>
                <div className="nav-button">Help</div>
            </div>

            <div id="standard-buttons">
			    <div className="toolbar-compound-button-wrapper">
                    <button className="toolbar-button lightweight back-button" disabled={enable} onClick={previousFolder}>
                        <span className="label-text">Back</span>
                        <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                    </button>
                </div>
                <div className="toolbar-compound-button-wrapper">
                    <button className="toolbar-button lightweight forward-button" disabled>
                        <span className="label-text">Forward</span>
                        <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                    </button>
                </div>
			</div>

            <div id="address-bar">
                <div className="nav-button">Address</div>
                <div className="bar-outer">
                    <div className="icon"></div>
                    <div className="bar">
                        <div className="bar-item"><span>C:\</span><span className="data-folder" data-folder="Home">Home</span></div>
                    </div>
                </div>
            </div>

            <div className="window-body-outer">
                <div className="window-body" data-folder="Home">
                    <div className="item">
                        <div className="icon folder" data-folder="Songs" onClick={openFolder}>Songs</div>
                    </div>
                    <div className="item">
                        <div className="icon folder" data-folder="Photos" onClick={openFolder}>Photos</div>
                    </div>
                    <div className="item">
                        <div className="icon folder" data-folder="Top Secret" onClick={openFolder}>Top Secret</div>
                    </div>
                    <div className="item">
                        <div className="icon game" data-folder="Games" onClick={openFolder}>Games</div>
                    </div>
                    <div className="item">
                        <div className="icon program" data-folder="Programs" onClick={openFolder}>Programs</div>
                    </div>
                </div>
                <div className="window-body songs hidden" data-folder="Songs">
                    <div className="item">
                        <div className="icon folder" data-folder="SALAM" onClick={openFolder}>Songs About Love and Money</div>
                    </div>
                </div>
                <div className="window-body salam hidden" data-folder="SALAM">
                    <div className="item">
                        <div className="icon folder" data-folder="I Took a Trip" onClick={openFolder}>I Took a Trip</div>
                    </div>
                    <div className="item">
                        <div className="icon folder" data-folder="Midnight" onClick={openFolder}>Midnight</div>
                    </div>
                    <div className="item">
                        <div className="icon folder" data-folder="Disco On Neptune" onClick={openFolder}>Disco On Neptune</div>
                    </div>
                    <div className="item">
                        <div className="icon folder" data-folder="The Good, The Bad & The Handsome" onClick={openFolder}>The Good, The Bad...</div>
                    </div>
                    <div className="item">
                        <div className="icon folder" data-folder="One Eye on the Door" onClick={openFolder}>One Eye on the Door</div>
                    </div>
                    <div className="item">
                        <a href="https://open.spotify.com/album/0EmnXilEYJtgA1H1yr6zAf?si=9JctfhQSR1yyhak1AgmeyA" className="icon audio-link" target="_blank" rel="noreferrer">Listen
                            <div className="shortcut-overlay"></div>
                        </a>
                    </div>
                    <div className="item">
                        <div className="icon image" onClick={showWindow} data-name="Image" data-song="Songs About Love and Money">artwork.jpg</div>
                    </div>
                </div>
                <div className="window-body i-took-a-trip hidden" data-folder="I Took a Trip">
                    <div className="item">
                        <div className="icon file" onClick={showWindow} data-name="Notepad" data-song="ITAT">ITAT.txt</div>
                    </div>
                    <div className="item">
                        <a href="https://open.spotify.com/track/6DSZYhFDuoTNN9VU4p0nae?si=1dd367289065421c" className="icon audio-link" target="_blank"rel="noreferrer">Listen
                            <div className="shortcut-overlay"></div>
                        </a>
                    </div>
                    <div className="item">
                        <div className="icon image" onClick={showWindow} data-name="Image" data-song="ITAT">ITAT.jpg</div>
                    </div>
                    <div className="item">
                        <a href="https://www.youtube.com/watch?v=YZ9anXFFimw" className="icon video" target="_blank" rel="noreferrer">ITAT.mp4</a>
                    </div>
                </div>
                <div className="window-body midnight hidden" data-folder="Midnight">
                    <div className="item">
                        <div className="icon file" onClick={showWindow} data-name="Notepad" data-song="Midnight">Midnight.txt</div>
                    </div>
                    <div className="item">
                        <a href="https://open.spotify.com/track/6T1c9O55gmaqx53OJNgKaf?si=1d73b67f7fd84254" className="icon audio-link" target="_blank" rel="noreferrer">Listen
                            <div className="shortcut-overlay"></div>
                        </a>
                    </div>
                    <div className="item">
                        <div className="icon image" onClick={showWindow} data-name="Image" data-song="Midnight">Midnight.jpg</div>
                    </div>
                </div>
                <div className="window-body disco-on-neptune hidden" data-folder="Disco On Neptune">
                    <div className="item">
                        <div className="icon file" onClick={showWindow} data-name="Notepad" data-song="DON">DON.txt</div>
                    </div>
                    <div className="item">
                        <a href="https://open.spotify.com/track/0ZQSuT3HRjOwSewqciJHPo?si=feac64c863724e92" className="icon audio-link" target="_blank" rel="noreferrer">Listen
                            <div className="shortcut-overlay"></div>
                        </a>
                    </div>
                    <div className="item">
                        <div className="icon image" onClick={showWindow} data-name="Image" data-song="DON">DON.jpg</div>
                    </div>
                </div>
                <div className="window-body the-good-bad-handsome hidden" data-folder="The Good, The Bad & The Handsome">
                    <div className="item">
                        <div className="icon file" onClick={showWindow} data-name="Notepad" data-song="TGBH">TGBH.txt</div>
                    </div>
                    <div className="item">
                        <a href="https://open.spotify.com/track/4uWohVpDyAmz6UJsPUps6e?si=d899362b7eda419a" className="icon audio-link" target="_blank" rel="noreferrer">Listen
                            <div className="shortcut-overlay"></div>
                        </a>
                    </div>
                    <div className="item">
                        <div className="icon image" onClick={showWindow} data-name="Image" data-song="TGBH">TGBH.jpg</div>
                    </div>
                </div>
                <div className="window-body one-eye-on-the-door hidden" data-folder="One Eye on the Door">
                    <div className="item">
                        <div className="icon file" onClick={showWindow} data-name="Notepad" data-song="OEOTD">OEOTD.txt</div>
                    </div>
                    <div className="item">
                        <a href="https://open.spotify.com/track/0bFWxmQbbFhCrShy73Yysf?si=eb381d4416c5421d" className="icon audio-link" target="_blank" rel="noreferrer">Listen
                            <div className="shortcut-overlay"></div>
                        </a>
                    </div>
                </div>
                <div className="window-body photos hidden" data-folder="Photos">
                    <Gallery renderGallery={renderGallery} selectedPhoto={selectedPhoto} onOpen={showViewer}/>
                </div>
                <div className="window-body top-secret hidden" data-folder="Top Secret">
                    <div className="item">
                        <div className="icon locked" data-folder="The Vault">The Vault</div>
                    </div>
                </div>
                <div className="window-body programs hidden" data-folder="Programs">
                    {/* <div className="item">
                        <div className="icon terminal" data-folder="Terminal">Terminal</div>
                    </div> */}
                    <div className="item">
                        <a href="https://open.spotify.com/artist/0COjQBYwITpwsJ7KVbQUbu" className="icon spotify" data-folder="Contact" target="_blank" rel="noreferrer">Spotify</a>
                    </div>
                    <div className="item">
                        <a href="https://www.instagram.com/beluckyband/" className="icon instagram" data-folder="Contact" target="_blank" rel="noreferrer">IG</a>
                    </div>
                    <div className="item">
                        <a href="https://www.google.com/search?q=beluckyband" className="icon internet2" data-folder="Internet" target="_blank" rel="noreferrer">Internet Explorer</a>
                    </div>
                    <div className="item">
                        <div className="icon outlook" data-name="Contact Form" onClick={openContactForm}>Outlook</div>
                    </div>
                    {/* <div className="item">
                        <div className="icon snake" onClick={openSnake} data-name="snake.exe" data-folder="snake.exe">Snake 2</div>
                    </div> */}
                </div>
                <div className="window-body games hidden" data-folder="Games">
                <div className="item">
                        <div className="icon snake" onClick={openSnake} data-name="Snake.exe">Snake 2</div>
                    </div>
                </div>
            </div>

        </div>
                
        </> 
    )
}